import React, { forwardRef, MutableRefObject } from 'react';
import { WithTranslationsProps } from 'react-utilities';
import { TGameData, TMetaData } from '../types/bedev1Types';
import { SponsoredGameTile, GameTile } from './GameTiles';
import { FeaturedGridTile } from './FeaturedGameTile';
import { TGameTileProps, TOnTileClick } from './GameTileUtils';
import '../../../../css/common/_gameGrid.scss';

export type TGameGridProps = {
  gameData: TGameData[];
  metaData: TMetaData;
  translate: WithTranslationsProps['translate'];
  onTileClick: TOnTileClick;
  tileRef?: MutableRefObject<HTMLDivElement | null>;
};

export const GameGridTile = forwardRef<
  HTMLDivElement,
  {
    emphasis: boolean;
  } & TGameTileProps
>(
  (
    {
      emphasis,
      ...props
    }: {
      emphasis: boolean;
    } & TGameTileProps,
    ref
  ) => {
    if (props.gameData.isSponsored) {
      return <SponsoredGameTile ref={ref} {...props} />;
    }

    if (emphasis) {
      return <FeaturedGridTile ref={ref} {...props} />;
    }

    return <GameTile ref={ref} {...props} />;
  }
);

export const GameGrid = forwardRef<HTMLDivElement, TGameGridProps>(
  ({ gameData, translate, metaData, onTileClick, tileRef }: TGameGridProps, forwardedRef) => {
    return (
      <div ref={forwardedRef} className='game-grid'>
        {gameData.map((data, positionId) => (
          <GameGridTile
            ref={ref => {
              if (
                ((metaData?.emphasis === true && positionId === 1) ||
                  (metaData?.emphasis === false && positionId === 0)) &&
                tileRef
              ) {
                // eslint-disable-next-line no-param-reassign
                tileRef.current = ref;
              }
            }}
            // eslint-disable-next-line react/no-array-index-key
            key={positionId}
            id={positionId}
            gameData={data}
            translate={translate}
            onTileClick={onTileClick}
            emphasis={metaData?.emphasis === true && positionId === 0}
          />
        ))}
      </div>
    );
  }
);

export default GameGrid;
